import React from 'react';
import { Form, Row, Col } from 'react-bootstrap';
import PropTypes from 'prop-types';

/**
 * Componente de formulário para edição de item do dicionário
 * Campos: Código (readonly ao criar) + Descrição
 */
export default function DicionarioForm({
  formData = { codigo: '', descricao: '' },
  setFormData,
  isCreating = false,
  isEditing = false,
  disabled = false,
}) {
  const handleCodigoChange = e => {
    const { value } = e.target;
    // Permite apenas números
    if (/^\d*$/.test(value)) {
      setFormData(prev => ({ ...prev, codigo: value }));
    }
  };

  const handleDescricaoChange = e => {
    const { value } = e.target;
    setFormData(prev => ({ ...prev, descricao: value }));
  };

  return (
    <div style={{ marginBottom: 10 }}>
      <Row className="align-items-end">
        <Col xs={12} sm={2} md={2} lg={1}>
          <Form.Group className="mb-2">
            <Form.Label
              style={{
                fontWeight: 'bold',
                color: '#008080',
                marginBottom: 2,
                fontSize: '0.9rem',
              }}
            >
              Código:
            </Form.Label>
            <Form.Control
              type="text"
              size="sm"
              value={formData.codigo}
              onChange={handleCodigoChange}
              readOnly={isCreating || !isEditing}
              disabled={disabled}
              style={{
                backgroundColor: isCreating ? '#fff3cd' : '#e9ecef',
                fontWeight: 'bold',
                textAlign: 'center',
                border: '2px solid #008080',
              }}
            />
          </Form.Group>
        </Col>
        <Col xs={12} sm={10} md={10} lg={11}>
          <Form.Group className="mb-2">
            <Form.Label
              style={{
                fontWeight: 'bold',
                color: '#008080',
                marginBottom: 2,
                fontSize: '0.9rem',
              }}
            >
              Descrição:
            </Form.Label>
            <Form.Control
              type="text"
              size="sm"
              value={formData.descricao}
              onChange={handleDescricaoChange}
              readOnly={!isEditing}
              disabled={disabled}
              autoFocus={isEditing}
              style={{
                backgroundColor: isEditing ? 'white' : '#e9ecef',
                border: isEditing ? '2px solid #007bff' : '1px solid #ced4da',
              }}
              placeholder={isEditing ? 'Digite a descrição...' : ''}
            />
          </Form.Group>
        </Col>
      </Row>
    </div>
  );
}

DicionarioForm.propTypes = {
  formData: PropTypes.shape({
    codigo: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    descricao: PropTypes.string,
  }),
  setFormData: PropTypes.func.isRequired,
  isCreating: PropTypes.bool,
  isEditing: PropTypes.bool,
  disabled: PropTypes.bool,
};
